import { render, staticRenderFns } from "./CustomTooltip.vue?vue&type=template&id=72b47804&scoped=true"
import script from "./CustomTooltip.vue?vue&type=script&lang=js"
export * from "./CustomTooltip.vue?vue&type=script&lang=js"
import style0 from "./CustomTooltip.vue?vue&type=style&index=0&id=72b47804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b47804",
  null
  
)

export default component.exports